import {ReactNode, useContext} from 'react';
import {
  InlineDataComponentRegistry,
  ObservabilityProvider,
  InlineDataProvider as Provider,
} from '@stripe-internal/inline-data';
import {
  ContactSalesForm,
  EmailVerification,
  MerchantIssueSummary,
  MerchantVerificationStatus,
  ProgrammableThermostatSample,
  MerchantPayoutStatus,
  UniversalHelpChannelMenu,
  UniversalHelpLiveAnswersResponse,
  MerchantVerificationAffectingPayouts,
  UniversalHelpSignInPrompt,
  UpdateBankAccount,
  ExpressDeleteAccount,
  MerchantFollowUpCase,
  LinkDeclines,
  ConnectedAccountChooser,
  TaxForm1099PreviousYear,
  TaxForm1099CurrentYear,
  LinkTransactionCard,
  IdealInquiryForm,
  UrlIntervention,
  RiskReviewForm,
  ChargeLookupForm,
  BusinessCard,
} from '@stripe-internal/mse-inline-data';
import {ConfigContext} from '../ConfigProvider';
import {useClientObservability} from '../ClientProvider/useClientObservability';
import {newInlineDataService} from './inline-data-service';
import {useApi} from '../ApiProvider/ApiProvider';

const components: InlineDataComponentRegistry = {
  'mse-inline-data:ContactSalesChatForm': ContactSalesForm,
  'mse-inline-data:ContactSalesEmailForm': ContactSalesForm,
  'mse-inline-data:EmailVerification': EmailVerification,
  'mse-inline-data:ProgrammableThermostat': ProgrammableThermostatSample,
  'mse-inline-data:MerchantIssueSummary': MerchantIssueSummary,
  'mse-inline-data:MerchantVerificationStatus': MerchantVerificationStatus,
  'mse-inline-data:UniversalHelpChannelMenu': UniversalHelpChannelMenu,
  'mse-inline-data:LiveAnswersResponse': UniversalHelpLiveAnswersResponse,
  'mse-inline-data:MerchantPayoutStatus': MerchantPayoutStatus,
  'mse-inline-data:MerchantVerificationAffectingPayouts':
    MerchantVerificationAffectingPayouts,
  'mse-inline-data:UniversalHelpSignInPrompt': UniversalHelpSignInPrompt,
  'mse-inline-data:UpdateBankAccount': UpdateBankAccount,
  'mse-inline-data:ExpressDeleteAccount': ExpressDeleteAccount,
  'mse-inline-data:MerchantFollowUpCase': MerchantFollowUpCase,
  'mse-inline-data:LinkDeclines': LinkDeclines,
  'mse-inline-data:ConnectedAccountChooser': ConnectedAccountChooser,
  'mse-inline-data:TaxForm1099CurrentYear': TaxForm1099CurrentYear,
  'mse-inline-data:TaxForm1099PreviousYear': TaxForm1099PreviousYear,
  'mse-inline-data:LinkTransactionCard': LinkTransactionCard,
  'mse-inline-data:IdealInquiryForm': IdealInquiryForm,
  'mse-inline-data:RiskUrlIntervention': UrlIntervention,
  'mse-inline-data:RiskReviewForm': RiskReviewForm,
  'mse-inline-data:ChargeLookupForm': ChargeLookupForm,
  'mse-inline-data:BusinessCard': BusinessCard,
};

export const InlineDataProvider = ({children}: {children: ReactNode}) => {
  const {entrypoint, audience} = useContext(ConfigContext);
  const observability = useClientObservability();
  const {fetch} = useApi();

  const service = newInlineDataService(fetch, {
    entry_point: entrypoint,
    audience,
  });

  return (
    <ObservabilityProvider config={observability}>
      <Provider value={{service, components}}>{children}</Provider>
    </ObservabilityProvider>
  );
};
